(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$scope', '$state', 'DataUtils', 'Product','NgTableParams'];

    function ProductController ($scope, $state, DataUtils, Product,NgTableParams) {
        var vm = this;
        
        vm.product = [];
//        vm.product = [{code:'BAB01',name:'Tan gia bại sản', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N1-NB sales',unit:'Quyển',seriesNum:'1457758 - 19999999',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
//                      {code:'BAB02',name:'Tán gia bại sản', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N2-NB sales',unit:'Tờ',seriesNum:'1457758 - 19999999',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
//                      {code:'BAB03',name:'Tích lũy cả đời', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N3-NB sales',unit:'Cái',seriesNum:'1457758 - 22222222',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
//                      {code:'BAB04',name:'An gia tích lũy định kỳ', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N4-NB sales',unit:'Quyển',seriesNum:'1457758 - 19999999',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
//                      {code:'BAB05',name:'An hưởng thịnh vượng', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N1-NF sales',unit:'Quyển',seriesNum:'1457758 - 44444444',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
//                      {code:'BHB06',name:'An hưởng thịnh vượng', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N1-NG sales',unit:'Quyển',seriesNum:'1457758 - 7777777',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'}];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	Product.query(function(result) {
                vm.product = result;
                if(vm.product !=null && vm.product.length > 0){
                	var i;
                	for( i = 0; i < vm.product.length; i++){
                		if(vm.product[i].status == 1){
                			vm.product[i].statusName = true;
                		}else{
                			vm.product[i].statusName = false;
                		}
                		if(vm.product[i].seriesIndicator == 1){
                			vm.product[i].seriesIndicatorName = true;
                		}else{
                			vm.product[i].seriesIndicatorName = false;
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 20
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.product
    				});
                }
            });
        }
    }
})();
